module.exports = __webpack_public_path__ + "img/department_of_mysteries_door.190c7d41.jpg";